var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0303 4.46967C13.3232 4.76256 13.3232 5.23744 13.0303 5.53033L7.31066 11.25H18.5C18.9142 11.25 19.25 11.5858 19.25 12C19.25 12.4142 18.9142 12.75 18.5 12.75H7.31066L13.0303 18.4697C13.3232 18.7626 13.3232 19.2374 13.0303 19.5303C12.7374 19.8232 12.2626 19.8232 11.9697 19.5303L4.96967 12.5303C4.67678 12.2374 4.67678 11.7626 4.96967 11.4697L11.9697 4.46967C12.2626 4.17678 12.7374 4.17678 13.0303 4.46967Z",
    fill: "white",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft24Line);
export default __webpack_public_path__ + "static/media/Arrow-Left-24-line.9864ea77c1f0c438717c72a6ce5062ce.svg";
export { ForwardRef as ReactComponent };